import _extends from "/app/node_modules/babel-runtime/helpers/extends";
import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _Promise from "/app/node_modules/babel-runtime/core-js/promise";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ListItem from "~/components/collaborators/slide-item";
import sellerDetail from "~/components/collaborators/seller-detail";
import newSellerModal from "~/components/collaborators/new-seller-modal";
// import chargeSellerModal from "~/components/collaborators/new-charge-seller-modal";
import alertModal from "~/components/collaborators/alert-modal";
import loader from "~/components/modals/loader";
import { mapState, mapActions } from "vuex";

export default {
    fetch: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
            var store = _ref.store,
                app = _ref.app;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            store.commit("dashboard/details/setToolbarTitle", "Colaboradores");
                            _context.prev = 1;
                            _context.next = 4;
                            return _Promise.all([store.dispatch("user/showListByRol")]);

                        case 4:
                            _context.next = 9;
                            break;

                        case 6:
                            _context.prev = 6;
                            _context.t0 = _context["catch"](1);

                            app.$controlMessage(_context.t0);

                        case 9:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, this, [[1, 6]]);
        }));

        function fetch(_x) {
            return _ref2.apply(this, arguments);
        }

        return fetch;
    }(),
    asyncData: function asyncData(_ref3) {
        var app = _ref3.app,
            redirect = _ref3.redirect;

        if (app.$isAdmin()) {
            return redirect("/bosses");
        } else if (app.$isBoss()) {
            return redirect("/channels");
        }
        return null;
    },

    components: {
        ListItem: ListItem,
        sellerDetail: sellerDetail,
        alertModal: alertModal,
        newSellerModal: newSellerModal,
        loader: loader
        // chargeSellerModal
    },
    data: function data() {
        var _$store$state$team$da = this.$store.state.team.dataTeam,
            Name = _$store$state$team$da.Name,
            IsActive = _$store$state$team$da.IsActive;

        return {
            buttonNewCollaborator: "",
            buttonAddColaborator: false,
            collaboratorsTitle: Name,
            status: IsActive,
            typeOfTable: "",
            conditionalNotContent: false,
            messageNotContent: "No hay contenido",
            isDetailSeller: false,
            loaderText: "Procesando información"
            // items: [
            //   { title: 'Agregar un nuevo vendedor', type: 1 },
            //   { title: 'Cargar lista de vendedores', type: 2 },
            // ]
        };
    },

    computed: _extends({}, mapState({
        listOfTeam: function listOfTeam(state) {
            return state.team.teams;
        }
    }), {
        arrayByUserRole: function arrayByUserRole() {
            if (this.$isSupervisor()) {
                return this.listOfTeam;
            } else {
                return this.teams;
            }
        }
    }),
    methods: {
        openNewItem: function openNewItem(type) {
            this.$refs.newSellerModal.teamIsActive = this.status;
            this.$refs.newSellerModal.addNewSeller();
            // if(type == 1) {
            // } else {
            //   this.$refs.chargeSellerModal.open()
            // }
        },

        // openNewItem2() {
        //     this.$refs.chargeSellerModal.teamIsActive = this.status
        // },
        completeForm: function completeForm() {
            this.$refs.alertModal.openModal();
        },
        editSellerTable: function editSellerTable(val) {
            this.$refs.loaderModal.showLoader();
            this.$router.push("/my-team/sellers/" + val.item.value);
        },
        upDateListBoss: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.$store.dispatch("user/showListByRol");

                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function upDateListBoss() {
                return _ref4.apply(this, arguments);
            }

            return upDateListBoss;
        }()
    },
    mounted: function mounted() {
        var _this = this;

        this.$nextTick(function () {
            _this.buttonNewCollaborator = "AGREGAR VENDEDOR";
            if (!_this.$isSupervisor()) _this.buttonAddColaborator = true;
            _this.$refs.newSellerModal.idUser = _this.$store.state.user.idTeam;
            //Si no hay contenido
            if (_this.arrayByUserRole[0].items.length === 0) {
                _this.conditionalNotContent = true;
                _this.messageNotContent = "No hay Vendedores asignados a este Equipo";
                _this.$refs.newSellerModal.conditionalIsSupervisor = true;
            } else {
                _this.conditionalNotContent = false;
                _this.$refs.newSellerModal.conditionalIsSupervisor = false;
            }
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/my-team/index.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/my-team/index.vue
// module chunks = 7